export const cancelBtnStyles = (theme) => ({
  root: {
    height: '48px',
    padding: 0,
    minWidth: '40px',
    backgroundColor: '#d5d5d5',
    color: '#000000',
    '&:hover': { backgroundColor: theme.palette.error.light, color: theme.palette.common.white },
  },
})
